/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrRipple } from './igr-ripple';
import { Ripple } from './Ripple';
import { TypeRegistrar } from "igniteui-react-core";
var IgrRippleModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrRippleModule() {
    }
    IgrRippleModule.register = function () {
        TypeRegistrar.registerCons('IgrRipple', IgrRipple);
        TypeRegistrar.registerCons('IgrRipple', IgrRipple);
        TypeRegistrar.register('Ripple', Ripple.$type);
    };
    return IgrRippleModule;
}());
export { IgrRippleModule };
//# sourceMappingURL=igr-ripple-module.js.map
